module.exports = __webpack_public_path__ + "static/media/exhibition-services-img16.4c93b441.jpg";